// extracted by mini-css-extract-plugin
export default {"additional":"additional-questions_additional__USYIj","_dark":"additional-questions__dark__cHwJt","tip":"additional-questions_tip__nv6AA"};